/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import Vue from 'vue';
import { ANCHOR_SHARP_REGEXP } from './utils.js';
import props from './anchor-item-props.js';
import { getClassPrefixMixins } from '../config-provider/config-receiver.js';
import mixins from '../utils/mixins.js';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '@babel/runtime/helpers/typeof';
import '../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../_chunks/dep-9849f16c.js';
import '../config-provider/type.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var classPrefixMixins = getClassPrefixMixins("anchor");
var _AnchorItem = mixins(Vue, classPrefixMixins).extend({
  name: "TAnchorItem",
  props: _objectSpread(_objectSpread({}, props), {}, {
    href: {
      type: String,
      required: true,
      validator: function validator(v) {
        return ANCHOR_SHARP_REGEXP.test(v);
      }
    }
  }),
  inject: {
    tAnchor: {
      "default": void 0
    }
  },
  watch: {
    href: {
      immediate: true,
      handler: function handler() {
        this.unregister();
        this.register();
      }
    }
  },
  destroyed: function destroyed() {
    this.unregister();
  },
  methods: {
    register: function register() {
      this.tAnchor.registerLink(this.href);
    },
    unregister: function unregister() {
      var href = this.href;
      if (!href) return;
      this.tAnchor.unregisterLink(href);
    },
    handleClick: function handleClick(e) {
      var href = this.href,
        tAnchor = this.tAnchor,
        title = this.title;
      tAnchor.handleScrollTo(href);
      tAnchor.handleLinkClick({
        href: href,
        title: typeof title === "string" ? title : void 0,
        e: e
      });
    },
    renderTitle: function renderTitle() {
      var title = this.title,
        $scopedSlots = this.$scopedSlots;
      var titleSlot = $scopedSlots.title;
      var titleVal;
      if (typeof title === "string") {
        titleVal = title;
      } else if (typeof title === "function") {
        titleVal = title(this.$createElement);
      } else if (titleSlot) {
        titleVal = titleSlot(null);
      }
      return titleVal;
    }
  },
  render: function render() {
    var _wrapperClass;
    var h = arguments[0];
    var href = this.href,
      target = this.target,
      $scopedSlots = this.$scopedSlots,
      tAnchor = this.tAnchor;
    var children = $scopedSlots["default"],
      titleSlot = $scopedSlots.title;
    var title = this.renderTitle();
    var titleAttr = typeof title === "string" ? title : null;
    var isActive = tAnchor.active === href;
    var wrapperClass = (_wrapperClass = {}, _defineProperty(_wrapperClass, "".concat(this.componentName, "__item"), true), _defineProperty(_wrapperClass, this.commonStatusClassName.active, isActive), _wrapperClass);
    var titleClass = _defineProperty({}, "".concat(this.componentName, "__item-link"), true);
    return h("div", {
      "class": wrapperClass
    }, [h("a", {
      "attrs": {
        "href": href,
        "title": titleAttr,
        "target": target
      },
      "class": titleClass,
      "on": {
        "click": this.handleClick
      }
    }, [titleSlot ? titleSlot(null) : title]), children && children(null)]);
  }
});

export { _AnchorItem as default };
//# sourceMappingURL=anchor-item.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/anchor/anchor-item.js
// module id = null
// module chunks = 